import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { range } from 'lodash';

import { tomorrow, substractDays} from '../../utils/dates';

@Component({
  selector: 'app-dialog-coupon-publish',
  templateUrl: './dialog-coupon-publish.component.html',
  styleUrls: ['./dialog-coupon-publish.component.sass']
})
export class DialogCouponPublishComponent implements OnInit {
  model = {
    choice: 'ASAP',
    date: tomorrow(),
    time: '00:00'
  };
  hours = range(24).map((v, i) => (i < 10 ? '0' + i : i) + ':00');

  constructor(
    public dialogRef: MatDialogRef<DialogCouponPublishComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const date = new Date(this.data.coupon.publication_date);
    const hours = date.getUTCHours();
    const minutes = date.getMinutes();

    this.model.date = date;
    this.model.time = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);

    if (date.getTime() !== tomorrow().getTime()) {
      this.model.choice = 'ASAP';
    } else {
      this.model.choice = 'DATE';
    }
  }

  ngOnInit() {
  }

  onConfirm() {
    const date = new Date(this.model.date);
    const time = this.model.time.substr(0, 2);
    date.setUTCHours(parseInt(time, 10), 0, 0);

    if (this.model.choice === 'ASAP') {
      this.dialogRef.close(tomorrow());
    } else {
      this.dialogRef.close(date);
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  getDateMin() {
    return new Date();
  }

  getDateMax() {
    if (this.data.coupon.start_date) {
      return substractDays(this.data.coupon.start_date, 1);
    }
  }
}
